import WebApi from "@/views/loyalty/shared/modules/web_api"

export class CardEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_LOYALTY_URL}api/card/`
        this.webApi = new WebApi()
    }

    async get_card (item) {
        const card = await this.webApi.post(`${this.url}`, { item: item })
        return card
    }

    async get_cards (page, limit, filter, search) {
        const cards = await this.webApi.post(`${this.url}`, {
            page: page,
            limit: limit,
            filter: filter,
            search: search
        })
        console.log('get_cards', cards)
        if (!cards.status_code) {
            return cards
        } else {
            console.error(`Ошибка с кодом: ${cards.status_code}`)
        }
    }
}
